import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SettingModel } from '../models/setting.model';
import { SessionStorageService } from './session-storage.service';

@Injectable({
    providedIn: 'root'
})

export class OrganisationSettingsApiClient {

    private API_ENDPOINT = environment.apiUrl + "/organisation/";
    private _organisationSettingsCache!: Observable<any[]> | null;

    constructor(private httpClient: HttpClient, private sessionStorageService: SessionStorageService) { }

    getOrganisationSettings(organisationGuid: string) {
        if (this.sessionStorageService.organisationGuid === organisationGuid) {
            return this.getOrganisationSettingsCache(organisationGuid);
        } else {
            return this.getOrganisationSettingsNonCache(organisationGuid);
        }
    }

    getOrganisationSettingsCache(organisationGuid: string) {
        if (!this._organisationSettingsCache) {
            this._organisationSettingsCache = this.httpClient.get<any[]>(this.API_ENDPOINT + organisationGuid + "/settings").pipe(
                map(data => data
                ),
                shareReplay(1)
            );
        }
        return this._organisationSettingsCache;
    }

    getOrganisationSettingsNonCache(organisationGuid: string) {
        return this.httpClient.get<any[]>(this.API_ENDPOINT + organisationGuid + "/settings");
    }

    postOrganisationSettings(organisationGuid: string, body: any) {
        if (this.sessionStorageService.organisationGuid === organisationGuid) {
            this._organisationSettingsCache = null;
        }
        return this.httpClient.post(this.API_ENDPOINT + organisationGuid + "/settings", body)
    }

    getReservedCredits(organisationGuid: string): Observable<number> {
        return this.httpClient.get<number>(this.API_ENDPOINT + organisationGuid + "/activeReservedCredits");
    }
    getIdin(organisationGuid: string) {
        return this.httpClient.get(this.API_ENDPOINT + organisationGuid + "/useidin");
    }

    getAuditTrail(organisationGuid: string) {
        return this.httpClient.get(this.API_ENDPOINT + organisationGuid + "/audittrail");
    }

    postIdin(organisationGuid: string, body: any) {
        return this.httpClient.post(this.API_ENDPOINT + organisationGuid + "/useidin", body);
    }

    postAuditTrail(organisationGuid: string, body: any) {
        return this.httpClient.post(this.API_ENDPOINT + organisationGuid + "/audittrail", body);
    }


    getCreditSaldoReminder(organisationGuid: string) {
        return this.httpClient.get<boolean>(this.API_ENDPOINT + organisationGuid + "/creditpercentage");
    }
}
